import { action, observable, runInAction } from 'mobx'
import { message } from 'hljd'
import { hashHistory } from 'react-router'
import Api from '@api/shou_xie/showCase'
import { NOOP } from '@hlj/hlj-utils'
import { getSessionMerchantInfo } from '@merchant-backend/util'

class Store {
  constructor(mode = 'page', onSuccess = NOOP, onError = NOOP) {
    this.mode = mode
    this.successCallback = onSuccess
    this.errorCallback = onError
  }
  imageSize = [
    {
      aspectTop: 538 / 580,
      sizeTextTop: '538*580',
      aspectBottom: 538 / 580,
      sizeTextBottom: '538*580'
    },
    {
      aspectTop: 1080 / 1036,
      sizeTextTop: '1080*1036'
    },
    {
      aspectTop: 1080 / 674,
      sizeTextTop: '1080*674'
    }
  ]
  @observable showCaseEntry = {}
  @observable editId = '' // 当前id
  @observable seat = ''
  @observable setMealShow = false //弹框
  @observable imageType = 2
  @observable photoIndex = '' //判断是图1还是图2选的，双图的第一张图是图1，其他是图2
  @observable selectedImageUp = ''
  @observable selectedInfoUp = {}
  @observable selectedTypeUp = ''
  @observable selectedImageDown = ''
  @observable selectedInfoDown = {}
  @observable selectedTypeDown = ''
  @observable editLoading = false //Loading

  /**
   * 切换版式
   */
  @action
  handleChangeImageType = e => {
    this.imageType = e.target.value
    this.selectedImageUp = ''
    this.selectedInfoUp = {}
    this.selectedTypeUp = ''
    this.selectedImageDown = ''
    this.selectedInfoDown = {}
    this.selectedTypeDown = ''
  }

  /**
   * 跳转结果选择
   * @param {Number} photoIndex 选择的图片的位置
   * @return {Null}
   */
  @action
  handleSelectResult = photoIndex => () => {
    this.photoIndex = photoIndex
    this.setMealShow = true
  }

  /**
   * 上传图片
   */
  @action
  uploadImage = type => (file, link) => {
    runInAction(() => {
      switch (type) {
        case 'TOP':
          this.selectedImageUp = link
          return
        case 'BOTTOM':
          this.selectedImageDown = link
      }
    })
  }

  /**
   * 删除图片
   */
  @action
  removeImage = type => () => {
    runInAction(() => {
      switch (type) {
        case 'TOP':
          this.selectedImageUp = ''
          return
        case 'BOTTOM':
          this.selectedImageDown = ''
      }
    })
  }
  //裁剪
  @action
  handleClipImage = type => ({ clipUrl }) => {
    // 裁剪完之后判断是否是 gif， 是的话拼接一下保真的参数 /unoptimize/1
    if (clipUrl.indexOf('.gif') > -1) {
      clipUrl = `${clipUrl}/unoptimize/1`
    }
    runInAction(() => {
      switch (type) {
        case 'TOP':
          this.selectedImageUp = clipUrl
          return
        case 'BOTTOM':
          this.selectedImageDown = clipUrl
      }
    })
  }

  @action
  init = async () => {
    this.editLoading = true
    const { posters: entryPosters } = this.showCaseEntry
    let params = {
      id: this.editId
    }
    const {
      data: { id, image_info, seat },
      success
    } = await Api.getInfoApi(params)

    runInAction(() => {
      this.editLoading = false

      // todo
      if (success) {
        const { show_type, posters = [] } = JSON.parse(image_info) || {}

        this.editId = id
        this.seat = seat
        this.imageType = show_type

        switch (+show_type) {
          case 1:
            this.selectedImageUp = posters[0].image_path
            this.selectedInfoUp = this.getSelectedInfo(
              entryPosters[0],
              posters[0].target_type
            )
            this.selectedTypeUp = posters[0].target_type
            this.selectedImageDown = posters[1].image_path
            this.selectedInfoDown = this.getSelectedInfo(
              entryPosters[1],
              posters[1].target_type
            )
            this.selectedTypeDown = posters[1].target_type
            return
          default:
            this.selectedImageUp = posters[0].image_path
            this.selectedInfoUp = this.getSelectedInfo(
              entryPosters[0],
              posters[0].target_type
            )
            this.selectedTypeUp = posters[0].target_type
            return
        }
      }
    })
  }
  getSelectedInfo = (data, type) => {
    switch (type) {
      case 267:
        return { type: 'mealList' }
      case 99:
        return { type: 'talk' }
      default:
        return data.entity
    }
  }
  /**
   * 检测数据合法性
   */
  isUsefullInfo = () => {
    switch (this.imageType) {
      case 1:
        if (this.selectedImageUp == '' || this.selectedImageDown == '') {
          message.warn('请上传橱窗图片')
          return false
        } else if (
          !Object.keys(this.selectedInfoUp).length ||
          !Object.keys(this.selectedInfoDown).length
        ) {
          message.warn('请选择跳转结果')
          return false
        }
        return true
      default:
        if (this.selectedImageUp == '') {
          message.warn('请上传橱窗图片')
          return false
        } else if (!Object.keys(this.selectedInfoUp).length) {
          message.warn('请选择跳转结果')
          return false
        }
        return true
    }
  }
  getPosterParam = userId => {
    const {
      imageType,
      selectedInfoUp,
      selectedInfoDown,
      selectedImageUp,
      selectedImageDown,
      selectedTypeUp,
      selectedTypeDown
    } = this
    switch (imageType) {
      case 1:
        return [
          {
            image_path: selectedImageUp,
            target_id: selectedInfoUp.id || userId,
            target_type: selectedTypeUp
          },
          {
            image_path: selectedImageDown,
            target_id: selectedInfoDown.id || userId,
            target_type: selectedTypeDown
          }
        ]
      default:
        return [
          {
            image_path: selectedImageUp,
            target_id: selectedInfoUp.id || userId,
            target_type: selectedTypeUp
          }
        ]
    }
  }
  //提交
  @action
  submit = async () => {
    let userId = getSessionMerchantInfo().user_id
    let { editId, seat, imageType } = this
    if (!this.isUsefullInfo()) {
      return
    }

    let params = {
      id: editId,
      seat: seat,
      image_info: {
        show_type: imageType,
        posters: this.getPosterParam(userId)
      }
    }
    const { success } = await Api.editApi(params)
    if (success) {
      if (this.mode === 'modal') {
        this.successCallback()
      } else {
        this.goBack()
      }
    }
  }

  goBack = () => {
    if (this.mode === 'modal') {
      this.errorCallback()
    } else {
      hashHistory.push('/localMerchant/showCase')
    }
  }
}
export default Store
